import type { RL, RP } from '@/api';
import type { AsyncExportTask } from './types';
import LzdAjax from '@/utils/lzd-ajax';
import { download } from '@/utils/common';
import LzdUtil from '@/utils/lzd-util';
import { toI18n } from '../i18n';
import fileUtil from '@/utils/file-util';

const BASE_URL = '/bsl/system/async/export/task';

/** 分页查询 */
export async function queryPage(param: RP = { where: [] }) {
  param = param ?? {};
  param.where = param.where ?? [];
  return LzdAjax.post<RL<AsyncExportTask>>(
    `${BASE_URL}/query/page`,
    param,
    false,
    true
  ).then((v) => v.data);
}

/** 下载文件 */
export async function downloadFile(row: AsyncExportTask) {
  const at = LzdUtil.parseDate(row.createdAt!);
  if (!at || Date.now() - at.getTime() > 1000 * 60 * 60 * 24 * 15) {
    return LzdUtil.tipsError(toI18n('文件过期，不能下载'));
  }
  if (!row.percent || row.percent < 100) {
    return LzdUtil.tipsError(toI18n('导出未完成，不能下载'));
  }
  const download = (url?: string, name?: string) => {
    if (!url || !url.startsWith('http')) {
      return;
    }
    const a = document.createElement('a');
    a.href = url;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
  };
  if (row.fileUrl) {
    download(LzdUtil.buildFileLink(row.fileUrl) + '&fileName=' + row.taskName);
  } else if (row.ossFilePath) {
    LzdAjax.post<string>(
      `${BASE_URL}/query/oss-link`,
      {
        pks: [row.seq],
        taskId: row.taskId,
        where: []
      },
      false,
      true
    ).then((v) => {
      if (v.code === 0) {
        download(v.data, row.taskName);
      } else {
        return LzdUtil.tipsError(v);
      }
    });
  }
}
/** 异步文件导出API */
export const asyncExportTaskApi = {
  queryPage: queryPage,
  downloadFile: downloadFile
};
